  <ngb-toast
        *ngFor="let toast of toastService.toasts"
        [class]="toast.classname"
        [autohide]="true"
        (hidden)="toastService.remove(toast)"
        [delay]="toast.delay || 3000"
        (hide)="toastService.remove(toast)"
      >
        <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
          <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
        </ng-template>

        <ng-template #text>{{ toast.textOrTpl }}</ng-template>
        <div [inlineSVG]="'assets/ico/clear-button.svg'" class="icon fill-white clear-search-icon" alt="clear" (click)="toastService.remove(toast)"></div>
  </ngb-toast>